// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GMiQ","delete":"styles_delete__3BML6","update":"styles_update__1ol0g","add":"styles_add__34Q4v"};